import { createContext, useContext } from "react";

/**
 * DOM slots in a dashboard widget's title row that a widget can render its own
 * controls into (via a React portal), so the controls share the title row
 * instead of taking extra bands above and below the content.
 *
 * Order in the title row (left to right, after the title text):
 * - `status`: the "Updated …" label + refresh button,
 * - `pager`: the list pagination,
 * - `toolbar`: the list toolbar ("Show all", density, column selection).
 *
 * The slots exist only on widgets that have a title. Without a title the context
 * value is `null` and widgets keep their controls in the body.
 */
export interface DashboardTitleSlots {
    status: HTMLElement | null;
    pager: HTMLElement | null;
    toolbar: HTMLElement | null;
}

export const DashboardTitleSlotsContext = createContext<DashboardTitleSlots | null>(null);

export const useDashboardTitleSlots = () => useContext(DashboardTitleSlotsContext);
